import { Suspense, lazy } from "react";
import { Routes, Route } from "react-router-dom";
import MinibioHome from "@/pages/MinibioHome";

const BioPublicPage = lazy(() => import("@/pages/BioPublicPage"));
// Kundenbezogene Seiten, auf die eine Mini-Website verlinken kann – auf minibio.info
// identisch wie auf dimedial.studio, nur ohne DIMEDIAL-Header/Footer/Branding.
const TicketEventPage = lazy(() => import("@/pages/TicketEventPage"));
const TicketVeranstalterPage = lazy(() => import("@/pages/TicketVeranstalterPage"));
const KartePage = lazy(() => import("@/pages/KartePage"));
const PassPage = lazy(() => import("@/pages/PassPage"));
const WalletAddPage = lazy(() => import("@/pages/WalletAddPage"));
const ScanZugangPage = lazy(() => import("@/pages/ScanZugangPage"));
const EinladungPage = lazy(() => import("@/pages/EinladungPage"));
const ListePage = lazy(() => import("@/pages/ListePage"));
const ListenHubPage = lazy(() => import("@/pages/ListenHubPage"));
const MedienVorschauPage = lazy(() => import("@/pages/MedienVorschauPage"));

/* App-Hülle für die Zweit-Domain minibio.info – Mini-Websites + die von ihnen verlinkten
   Kundenseiten (Tickets/Events, Wallet/Karte, Listen, Vorschau …), KEIN DIMEDIAL-Branding.
   Echte DIMEDIAL-Seiten (Start, Preise, Login, Portal, Admin) sind nicht geroutet → neutrale Startseite. */
export default function MinibioApp() {
  return (
    <Suspense fallback={<div className="min-h-screen bg-ink" />}>
      <Routes>
        <Route path="/" element={<MinibioHome />} />
        {/* Kundenbezogene Seiten */}
        <Route path="/t/:slug" element={<TicketEventPage />} />
        <Route path="/v/:slug" element={<TicketVeranstalterPage />} />
        <Route path="/karte/:oid/:tid" element={<KartePage />} />
        <Route path="/pass" element={<PassPage />} />
        <Route path="/wallet/hinzufuegen" element={<WalletAddPage />} />
        <Route path="/scan/:token" element={<ScanZugangPage />} />
        <Route path="/einladung/:token" element={<EinladungPage />} />
        <Route path="/l" element={<ListenHubPage />} />
        <Route path="/l/:lid" element={<ListePage />} />
        <Route path="/vorschau/:aid/:token" element={<MedienVorschauPage />} />
        {/* Mini-Website nach Handle (zuletzt, damit die spezifischen Routen zuerst greifen) */}
        <Route path="/@:handle" element={<BioPublicPage minibio neutralFallback={<MinibioHome />} />} />
        <Route path="/:handle" element={<BioPublicPage minibio neutralFallback={<MinibioHome />} />} />
        <Route path="*" element={<MinibioHome />} />
      </Routes>
    </Suspense>
  );
}
